export enum NodeType {
    INCOMING_CALL = 'incoming-call',
    PLAY_TEXT = 'play-text',
    USER_INPUT = 'user-input',
    TO_OPERATOR = 'to-operator',
    DISCONNECT = 'disconnect',
    CHECK_SCHEDULE = 'check-schedule',
    QUEUE_CALL = 'queue-call',
    VOICE_MAIL = 'voice-mail',
    TRANSFER_CALL = 'transfer-call',
}
